var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nwmap" }, [
    _c("section", { staticClass: "nwmap-panel nwmap-world" }, [
      _c("div", { staticClass: "nwmap-head" }, [
        _c("span", { staticClass: "nwmap-pip" }),
        _vm._v(" Global coverage "),
        _c("span", { staticClass: "nwmap-tag home" }, [
          _vm._v(_vm._s(_vm.current.label)),
        ]),
      ]),
      _c("div", { staticClass: "nwmap-canvas world" }, [
        _c(
          "svg",
          {
            ref: "worldSvg",
            style: { cursor: _vm.dragging ? "grabbing" : "grab" },
            attrs: {
              viewBox: `0 0 ${_vm.WW} ${_vm.WH}`,
              preserveAspectRatio: "xMidYMid meet",
              role: "img",
              "aria-label": `세계지도 — ${_vm.current.label} 선택됨. 국가 선택은 상단 국가 목록을 이용하세요.`,
            },
            on: {
              pointerdown: _vm.onDown,
              pointermove: _vm.onMove,
              pointerup: _vm.onUp,
              pointerleave: _vm.onUp,
            },
          },
          [
            _c(
              "g",
              { attrs: { transform: _vm.groupTransform } },
              [
                _vm._l(_vm.worldPaths, function (p, i) {
                  return _c("path", {
                    key: "w" + i,
                    class: [
                      "nwmap-geo",
                      { home: p.home, preview: p.preview, codable: p.seq },
                    ],
                    attrs: { d: p.d, "data-seq": p.seq },
                    on: {
                      mouseover: function ($event) {
                        return _vm.onGeoOver(p)
                      },
                      mouseout: function ($event) {
                        return _vm.onGeoOut()
                      },
                      click: function ($event) {
                        return _vm.onGeoClick(p)
                      },
                    },
                  })
                }),
                _vm.worldPin
                  ? _c(
                      "g",
                      {
                        attrs: {
                          transform: `translate(${_vm.worldPin[0]},${_vm.worldPin[1]})`,
                          "pointer-events": "none",
                        },
                      },
                      [
                        _c("circle", {
                          staticClass: "nwmap-ring",
                          attrs: { r: "9" },
                        }),
                        _c("line", {
                          staticClass: "nwmap-stem",
                          attrs: { x1: "0", y1: "0", x2: "0", y2: "-15" },
                        }),
                        _c("g", { attrs: { transform: "translate(0,-15)" } }, [
                          _c("rect", {
                            staticClass: "nwmap-pill",
                            attrs: {
                              x: -4,
                              y: "-14",
                              width: _vm.pillW,
                              height: "16",
                              rx: "5",
                            },
                          }),
                          _c(
                            "text",
                            {
                              staticClass: "nwmap-pill-txt",
                              attrs: {
                                x: _vm.pillW / 2 - 4,
                                y: "-6",
                                dy: ".35em",
                                "text-anchor": "middle",
                              },
                            },
                            [_vm._v(_vm._s(_vm.current.label))]
                          ),
                        ]),
                        _c("circle", {
                          staticClass: "nwmap-dot",
                          attrs: { r: "3.4" },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.hoverPin
                  ? _c(
                      "g",
                      {
                        attrs: {
                          transform: `translate(${_vm.hoverPin.x},${_vm.hoverPin.y})`,
                          "pointer-events": "none",
                        },
                      },
                      [
                        _c("circle", {
                          staticClass: "nwmap-hdot",
                          attrs: { r: "3.2" },
                        }),
                        _c("g", { attrs: { transform: "translate(0,-13)" } }, [
                          _c("rect", {
                            staticClass: "nwmap-hpill",
                            attrs: {
                              x: "-4",
                              y: "-13",
                              width: _vm.hoverPin.w,
                              height: "16",
                              rx: "5",
                            },
                          }),
                          _c(
                            "text",
                            {
                              staticClass: "nwmap-hpill-txt",
                              attrs: {
                                x: _vm.hoverPin.w / 2 - 4,
                                y: "-5",
                                dy: ".35em",
                                "text-anchor": "middle",
                              },
                            },
                            [_vm._v(_vm._s(_vm.hoverPin.label))]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
    ]),
    _c(
      "aside",
      {
        key: _vm.seq,
        ref: "inset",
        staticClass: "nwmap-panel nwmap-inset",
        class: { hidden: _vm.insetHidden, big: _vm.insetBig },
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("div", { staticClass: "nwmap-head" }, [
          _c("span", { staticClass: "nwmap-pip" }),
          _vm._v(" " + _vm._s(_vm.current.label) + " focus "),
          _c("span", { staticClass: "nwmap-tag zoom" }, [_vm._v("ZOOM")]),
        ]),
        _c("div", { staticClass: "nwmap-canvas inset" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: `0 0 ${_vm.IW} ${_vm.IH}`,
                preserveAspectRatio: "xMidYMid meet",
              },
            },
            [
              _vm._l(_vm.insetPaths, function (p, i) {
                return _c("path", {
                  key: "i" + i,
                  class: ["nwmap-geo2", { home: p.home }],
                  attrs: { d: p.d },
                })
              }),
              _vm._l(_vm.insetMarkersDraw, function (m, i) {
                return _c(
                  "g",
                  {
                    key: "m" + i,
                    staticClass: "nwmap-mk-g",
                    attrs: {
                      transform: `translate(${m.x},${m.y}) scale(${_vm.mkScale})`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("city", {
                          name: m.name,
                          ofcCd: m.ofcCd,
                        })
                      },
                    },
                  },
                  [
                    m.primary
                      ? _c("g", [
                          !_vm.current.geo
                            ? _c("circle", {
                                staticClass: "nwmap-mk-glow",
                                attrs: { r: "26" },
                              })
                            : _vm._e(),
                          _c("circle", {
                            staticClass: "nwmap-mk-pulse",
                            attrs: { r: _vm.current.geo ? 15 : 26 },
                          }),
                        ])
                      : _vm._e(),
                    m.primary
                      ? _c("circle", {
                          staticClass: "nwmap-mk-ring",
                          attrs: { r: "13" },
                        })
                      : _vm._e(),
                    _c("rect", {
                      class: m.primary ? "nwmap-mk" : "nwmap-mk2",
                      attrs: {
                        x: "-4.2",
                        y: "-4.2",
                        width: "8.4",
                        height: "8.4",
                        rx: "1.6",
                      },
                    }),
                    _c(
                      "text",
                      {
                        staticClass: "nwmap-mk-label",
                        style: { fontSize: m.fs + "px" },
                        attrs: { "text-anchor": m.anchor, dx: m.dx, dy: m.dy },
                      },
                      [_vm._v(_vm._s(m.disp))]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }